import { RouteRecordRaw } from 'vue-router';

import CallList from '@/components/pages/va-app/CallList.vue';
import Setting from '@/components/pages/va-app/Setting.vue';
import Transcription from '@/components/pages/va-app/Transcription.vue';
import VaAppIndex from '@/components/pages/va-app/VaAppIndex.vue';
import { i18nGlobal as i18n } from '@/i18n';

export const vaAppRoutes: RouteRecordRaw[] = [
  {
    path: '/va-app',
    component: VaAppIndex,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        redirect: { name: 'VaCallList' },
      },
      {
        path: 'setting/:tab?/:subTab?',
        name: 'VaSetting',
        component: Setting,
        meta: {
          rule: 'isVaUser',
          title: i18n.t('corpSetting.title'),
        },
      },
      {
        path: 'call-list',
        name: 'VaCallList',
        component: CallList,
        meta: {
          rule: 'isVaUser',
        },
      },
      {
        path: 'call-list/:id/transcription',
        name: 'VaTranscription',
        component: Transcription,
        meta: {
          rule: 'isVaUser',
        },
      },
    ],
  },
];
